module.exports = __webpack_public_path__ + "img/petersone.f7f4a0e0.jpg";